var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasCrossprice || _vm.currentShopSale || _vm.availabilityStr != ""
    ? _c("div", { staticClass: "special-tags" }, [
        _vm.hasCrossprice
          ? _c("span", {
              staticClass: "tag percentage",
              domProps: { innerHTML: _vm._s(_vm.percentage) }
            })
          : _vm.currentShopSale
          ? _c("span", {
              staticClass: "tag percentage",
              domProps: { innerHTML: _vm._s(_vm.currentShopSaleText) }
            })
          : _vm._e(),
        _vm._v(" "),
        _vm.availabilityStr != ""
          ? _c("span", {
              staticClass: "tag delivery",
              domProps: { innerHTML: _vm._s(_vm.availabilityStr) }
            })
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }